import { useEffect, useRef, useState } from 'react';
import DropdownComponent from 'components/Settings/WebsiteFeeds/DropdownComponent';

const LastInteractionDateFilter = ({ filter, selectOption, showTitle }) => {
  const { name, options: propOptions } = filter;
  const options = propOptions.filter((option) => !option.hidden);
  const customIndex = options.findIndex((option) => option.isCustom);
  const customOption = options[customIndex];
  const selectedOption = options.find((option) => option.selected);

  const [customDaysEditing, setCustomDaysEditing] = useState(false);
  const [customDaysInput, setCustomDaysInput] = useState('');
  const customDaysInputRef = useRef(null);

  useEffect(() => {
    if (customDaysEditing) customDaysInputRef.current?.focus();
  }, [customDaysEditing]);

  const selectSingle = (index) => {
    const newValue = options.map((option, i) => ({ ...option, selected: i === index }));
    selectOption({ filter, newValue });
  };

  const saveCustomValue = () => {
    if (!customDaysInput) {
      setCustomDaysEditing(false);
      return;
    }
    // `name` isn't just this component's own display text - DropdownFilter.jsx's pill phrase and
    // filtersHashes.js's URL hash both read the option's raw name directly, so it has to carry the
    // real value too, not stay the static "Custom" placeholder from the filter's initial data.
    const newValue = options.map((option, i) => ({
      ...option,
      selected: i === customIndex,
      ...(i === customIndex ? { filterValue: customDaysInput, name: `in the last ${customDaysInput} days` } : {}),
    }));
    selectOption({ filter, newValue });
    setCustomDaysEditing(false);
  };

  const mainItem = () => (
    <span className='hidden-lines hidden-one-line w-100'>
      {selectedOption
        ? selectedOption.isCustom
          ? `In the last ${selectedOption.filterValue} days`
          : selectedOption.name
        : 'Select a value'}
    </span>
  );

  return (
    <div className='mb-3'>
      {showTitle && <h3>{name}</h3>}
      <DropdownComponent
        fixedDropdown
        waitOnOpen={false}
        notCloseOnSelect={customDaysEditing}
        onClose={() => setCustomDaysEditing(false)}
        mainItem={mainItem}
      >
        <ul className='policy-list px-0 pt-1 m-0 pb-2'>
          {options.map(
            (option, index) =>
              !option.isCustom && (
                <li
                  className='list-action-button px-3 py-2 flex-centered justify-content-between pointer'
                  key={`option-${index}`}
                  onClick={() => selectSingle(index)}
                >
                  <span>{option.name}</span>
                  {option.selected && <span className='icon-tick paragraph-p5' />}
                </li>
              )
          )}
          {customDaysEditing ? (
            <li className='d-flex align-items-center pl-2 pr-3 flex-centered justify-content-between pb-1 w-100'>
              <div className='d-flex align-items-center border-general border-grey-50 rounded specific-left-padding-6 pr-2 py-1 mr-1'>
                <input
                  ref={customDaysInputRef}
                  type='text'
                  inputMode='numeric'
                  pattern='[0-9]*'
                  className='no-focus-outline input-empty'
                  style={{ width: 150 }}
                  value={customDaysInput}
                  onChange={(e) => setCustomDaysInput(e.target.value.replace(/[^0-9]/g, ''))}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') saveCustomValue();
                  }}
                />
                <span className='text-main-blue-50 specific-left-padding-1'>days</span>
              </div>
              <button type='button' className='general-button text-light-blue' onClick={saveCustomValue}>
                Save
              </button>
            </li>
          ) : (
            <li
              className='list-action-button px-3 py-2 flex-centered justify-content-between pointer'
              onClick={() => {
                if (customOption?.filterValue) selectSingle(customIndex);
                else {
                  setCustomDaysInput('');
                  setCustomDaysEditing(true);
                }
              }}
            >
              <span>{customOption?.filterValue ? `Custom: ${customOption.filterValue} days` : 'Custom'}</span>
              {customOption?.filterValue && (
                <span className='d-flex align-items-center' style={{ gap: 8 }}>
                  <span
                    className='pointer icon-edit-pencil-thick paragraph-p3'
                    onClick={(e) => {
                      e.stopPropagation();
                      setCustomDaysInput(customOption.filterValue);
                      setCustomDaysEditing(true);
                    }}
                  />
                  {customOption.selected && <span className='icon-tick paragraph-p5' />}
                </span>
              )}
            </li>
          )}
        </ul>
      </DropdownComponent>
    </div>
  );
};

export default LastInteractionDateFilter;
